<template>
    <hb-modal v-model="dialog" size="large" :title="taskTitle" show-help-link>
        <template v-slot:content>
            <hb-task
                :modal-view="true" 
                v-if="taskDataUpdated"
                class="task-details-modal"
                :type="taskDataUpdated.type"
                :hot-task="taskDataUpdated.hotTask"
                :icon="taskDataUpdated.icon | getIcon"
                :title="taskDataUpdated.title"
                :time="taskDataUpdated.time | formatDateServices"
                :assigned-to="taskDataUpdated.assignedTo"
                :created-by="taskDataUpdated.createdBy" 
                :created-by-time="taskDataUpdated.createdByTime | formatLocalDateTimeServices"
                :completed-by="taskDataUpdated.completedBy ? taskDataUpdated.completedBy : ''"
                :completed-by-time="taskDataUpdated.completedByTime | formatLocalDateTimeServices" 
                :updated-by="taskDataUpdated.updatedBy" 
                :updated-by-time="taskDataUpdated.updatedByTime | formatLocalDateTimeServices"
                :attachments="taskDataUpdated.attachments ? taskDataUpdated.attachments : ''" 
                :space="taskDataUpdated.space"
                :spaceType="taskDataUpdated.space ? taskDataUpdated.spaceType : ''"
                :expanded.sync="expanded"
                :contact-name="taskDataUpdated.contactName" 
                :contact-status="taskDataUpdated.contactStatus"
                :contact-is-business="taskDataUpdated.contactIsBusiness"
                :property="taskDataUpdated.property"
                :status="taskDataUpdated.labelStatus"
                :timer-green-value="taskDataUpdated.timerGreenValue"
                :timer-red-value="taskDataUpdated.timerRedValue" 
            >
                <div class="mb-4">{{ taskDataUpdated.details }}</div>
                <hb-media-viewer
                    v-if="taskDataUpdated.mediaFiles?.length"
                    v-model="mediaViewer"
                    grid
                    grid-padding-off
                >
                    <template v-slot:slides>
                        <slide
                            v-for="(slide, i) in taskDataUpdated.mediaFiles"
                            :key="'slide_' + i"
                            :video="slide.video"
                            :video_src="slide.video_src"
                            :src="slide.src"
                        />
                    </template>
                </hb-media-viewer>

                <div v-if="taskDataUpdated.documents?.length">
                    <div class="hb-font-body-medium hb-text-night mt-n3">Attachments</div>
                    <div class="mt-3">
                        <v-chip 
                            v-for="file in taskDataUpdated.documents" 
                            class="ma-1"
                            color="primary"
                            outlined
                            small
                            pointer
                            @click="openPdf(file.upload_id ? file.data_url : file, file.name, file.upload_id ? true : false)"
                        >{{ file.name }}</v-chip>
                    </div>
                </div>

            </hb-task>
        </template>
        <template v-slot:right-actions>
            <hb-btn v-if="taskDetails?.TaskType?.is_automated == 0" :loading="isDismissing" :disabled="isDismissing || (taskDataUpdated.status && (taskDataUpdated.status === 'complete' || taskDataUpdated.status === 'dismissed')  ? true : false)" color="secondary" @click="updateTaskStatusEvent('dismissed')">Dismiss</hb-btn>
            <!-- <hb-btn color="secondary" @click="updateTaskStatusEvent('inprogress')">In-Progress</hb-btn> -->
            <hb-btn  :loading="isCompleting" :disabled="isCompleting || (taskDataUpdated.status && (taskDataUpdated.status === 'complete' || taskDataUpdated.status === 'dismissed') ? true : false)" @click="updateTaskStatusEvent('completed')">Complete</hb-btn>
        </template>
    </hb-modal>
</template>

<script>
import api from '../../../assets/api.js';
import { notificationMixin } from '../../../mixins/notificationMixin.js';
import moment from 'moment';
import { EventBus } from '../../../EventBus.js';

export default {
    name: 'TaskDetails',
    mixins: [notificationMixin],
    data() {
        return {
            mediaViewer: false,
            expanded: false,
            isCompleting: false,
            isDismissing: false,
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        taskDetails: {
            type: Object,
            default: {}
        },
        primaryRoleProperties: {
            type: Array,
            default: []
        },
        fetchTasks: {
            type: Function,
            default: () => {}
        }
    },
    computed: {
        dialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        taskTitle() {
            let title = this.taskDetails?.TaskType ? this.taskDetails?.TaskType.label : 'Task Generic';
            title = title === 'Automated Communication' ? 'Operations' : title === 'Maintenance & Space Prep' ? 'maintenance' : title;
            return title;
        },
        taskDataUpdated() {
            if (!this.taskDetails) {
                return;
            }
            let item = this.taskDetails;
            let association = '';
            let assignees = '';
            let property = '';
            let attachments = [];
            let documents = [];
            let contactData = null;
            if (item.Associations?.lease?.length) association = 'contact';
            else if(item.Associations?.space?.length) association = 'space';
            else if(item.Associations?.property?.length) association = 'property';
            else association = undefined;
            if (item.Assignees && (item.Assignees.Contacts?.length || item.Assignees.Roles?.length)) {
                let contacts = item.Assignees.Contacts.map(item => item && item.first + ' ' + item.last)
                let roles = item.Assignees.Roles.map(item => item && item.name);
                assignees = [...contacts, ...roles].join(', ');
            } else assignees = 'Everyone'

            if (association === 'property') {
                property = item.Associations?.property[0];
            }
            if (association === 'space' && this.primaryRoleProperties.find(itemInner => itemInner.id === item.Associations?.space[0].property_id)) {
                property = this.primaryRoleProperties.find(itemInner => itemInner.id === item.Associations?.space[0].property_id);
            }
            if (association === 'contact' && this.primaryRoleProperties.find(itemInner => itemInner.id === item.Associations?.lease[0].Property.id)) {
                property = this.primaryRoleProperties.find(itemInner => itemInner.id === item.Associations?.lease[0].Property.id);
            }

            if (property) {
                property = (property.number ? property.number + ' - ' : '') + (property.city ? property.city + ' - ' : '') + property.name;
            }

            if (item.Associations?.lease?.length) {
                contactData = item.Associations?.lease[0].Tenants[0].Contact;
            }
            if (item.Associations?.contact?.length) {
                contactData = item.Associations?.contact[0];
                association = 'contact';
            }
            if (item.Attachments?.length) {
                let images = item.Attachments.filter(item => item.mimetype.includes('image'));
                let videos = item.Attachments.filter(item => item.mimetype.includes('video'));
                let files = item.Attachments.filter(item => item.mimetype.includes('pdf'));
                if (images.length) attachments.push(images.length + (images.length > 1 ? ' images' : ' image'));
                if (videos.length) attachments.push(videos.length + (videos.length > 1 ? ' videos' : ' video'));
                if (files.length) {
                    attachments.push(files.length + (files.length > 1 ? ' attachments' : ' attachment'));
                    for (const element of files) {
                        documents.push(element)
                    }
                }
            }

            let labelStatus = '';
            if (item.status === 'completed') {
                labelStatus = 'complete';
            } else if(item.status === 'dismissed') {
                labelStatus = 'dismissed';
            } else if(item.is_overdue) {
                labelStatus = 'overdue';
            } else if(item.hot_task && !item.is_overdue) {
                if (this.getTaskColor(item.due_date).color === 'green') {
                    labelStatus = 'timer green';
                } else {
                    labelStatus = 'timer red';
                }
            } else {
                labelStatus = item.status;
            }
            let taskObject = {
                id: item.id,
                type: association === 'property' ? 'space' : association,
                hotTask: item.hot_task ? true : false,
                icon: item.TaskType.icon,
                title: item.title ? item.title : item.TaskType.name,
                title: item.TaskType.slug === 'other' && item.title ? item.title : item.TaskType.name,
                time: item.due_date ? item.due_date.split(' ')[0] : '',
                assignedTo: assignees,
                createdBy: item.created_by_details ? item.created_by_details.first + ' ' + item.created_by_details.last : '',
                createdByTime: item.created_at,
                updatedBy: item.modified_by_details ? item.modified_by_details.first + ' ' + item.modified_by_details.last : '', 
                updatedByTime: item.modified_at,
                attachments: attachments.length ? attachments.join(', ') : '',
                space: association === 'space' ? item.Associations?.space[0].number : association === 'contact' && property ? item.Associations?.lease[0]?.Unit.number  : '',
                expanded: false,
                contactId: contactData ? contactData.id : '',
                contactName: contactData ? contactData.first + ' ' + contactData.last : '',
                contactStatus: contactData? contactData.contact_status ? contactData.contact_status : contactData.status : '',
                contactIsBusiness: contactData?.contact_type == 'Business' ? true : false,
                property: property,
                details: item.details,
                mediaFiles: item.mediaFiles,
                documents,
                spaceType: association === 'contact' && property ? item.Associations?.lease[0]?.Unit.type : association === 'space' ? item.Associations?.space[0].type : '',
                status: item.status,
                labelStatus,
                timerGreenValue: !item.is_overdue && item.hot_task && this.getTaskColor(item.due_date).color === 'green' ? this.getTaskColor(item.due_date).text : '',
                timerRedValue: !item.is_overdue && item.hot_task && this.getTaskColor(item.due_date).color === 'red' ? this.getTaskColor(item.due_date).text : ''
            };
            if (item.status === 'completed' || item.status === 'dismissed') {
                taskObject = {
                    ...taskObject,
                    completedBy: item.modified_by_details ? item.modified_by_details.first + ' ' + item.modified_by_details.last : '',
                    completedByTime: item.modified_at
                }
            }
            return taskObject;
        }
    },
    filters: {
        formatDateServices(value){
            if (!value || moment(value).format('MM/DD/YYYY') == 'Invalid date') return '';
            return moment(value).format('MMM DD, YYYY');
        },
        formatLocalDateTimeServices(value){
            if (!value) return '';
            return moment.utc(value).local().format('MMM DD, YYYY [@] h:mma');
        }
    },
    methods: {
        async updateTaskStatusEvent(params) {
            try {
                console.log('this.taskDetails.TaskType.slug :>> ', this.taskDetails.TaskType.slug);
                let lease = this.taskDetails.Associations?.lease?.length ? this.taskDetails.Associations?.lease[0] : null;
                if (this.taskDetails.TaskType.slug === 'lock_removal' && lease) {
                    await this.$store.dispatch('taskCenterStore/removeOverlock', { unit_id: lease.Unit.id, lease_id: lease.id });
                    EventBus.$emit('fetch_unit_gate_status');
                } else if (this.taskDetails.TaskType.slug === 'overlock_space' && lease) {
                    await this.$store.dispatch('taskCenterStore/overlockSpace', { unit_id: lease.Unit.id, lease_id: lease.id });
                    EventBus.$emit('fetch_unit_gate_status');
                } else {
                    if (params === 'dismissed') this.isDismissing = true;
                    if (params === 'completed') this.isCompleting = true;
                    // if (params === 'inprogress') this.isCompleting = true;
                    await api.post(this, api.TASKS_CENTER + this.taskDetails.id + '/update-status', { status: params });
                }
                this.dialog = false;
                this.fetchTasks(true);
            } catch (error) {
                this.showMessageNotification({type: 'error', description: error});
            } 
            finally {
                this.isCompleting = false;
                this.isDismissing = false;
            }
        },
        getTaskColor(params) {
            let dbTime = moment.utc(params);
            let currentTime = moment.utc();
            let diffMinutes = currentTime.diff(dbTime, "minutes");
            let diffHours = currentTime.diff(dbTime, "hours");
            let text ='', color = '';
            if (diffHours > 0) {
                text = `${diffHours} hrs ago`;
                color = "red";
            }
            else if(diffMinutes > 5) {
                text = `${diffMinutes} mins`;
                color = "red";
            } else {
                text = `${diffMinutes} mins`;
                color = "green";
            }
            return { text, color };
        },
        openPdf(fileData, name, isUploadedFile = false) {
            if (isUploadedFile) {
                const byteCharacters = atob(fileData);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                fileData = new Blob([byteArray], { type: 'application/pdf' });
            }
            const fileURL = URL.createObjectURL(fileData);
            window.open(fileURL, '_blank');
            const link = document.createElement('a');
            link.href = fileURL;
            link.download = name || 'document.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => URL.revokeObjectURL(fileURL), 1000);
        }
    },
}
</script>

<style scoped lang="scss">
.empty-image-box {
    width: 125px;
    height: 125px;
    border: 1.5px dashed #C4CDD5;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 4px;

    p {
        font-size: 14px;
        font-weight: 400;
        line-height: 23.8px;
        text-align: center;
        text-decoration-line: underline;
        text-decoration-style: solid;
        color: #00848E;
    }
}

.img-boxes {
    display: flex;
    // justify-content: space-between;
}

.image-box {
    width: 125px;
    height: 125px;
    overflow: hidden;
    position: relative;

    img,
    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &.cover-image:after {
        content: "Cover Image";
        position: absolute;
        left: 50%;
        bottom: 7px;
        color: white;
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        width: 100%;
        transform: translateX(-30%);

    }

    .img-box-last {
        position: absolute;
        left: 0;
        top: 0;
        width: 125px;
        height: 125px;
        // background-color: rgba(0, 0, 0, 0.5);
        background: #363636B2;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 24px;
        font-weight: 500;
        line-height: 32px;
    }
}

.top--2px {
    position: relative;
    top: -2px;
    padding: 0 4px;
    padding-right: 8px;
}

.image-upload input[type="file"] {
    display: none;
}
</style>

<style>
.task-details-modal .hb-task-background .hb-task-expanded-content-wrapper {
    padding-left: 20px !important;
}
</style>